
import { useSidePanel } from 'contexts/SidePanel';
import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck, faRotateLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import classes from './EditLayoutPanelContent.module.scss';
import { SortableList } from 'features/dndKit/components/SortableList';
import cardData, { LS_KEY, NavigationCardData } from '../NavigationCard/NavigationCardData';
import { storage } from "util/localStorage";

export default function EditLayoutPanelContent() {
  const [defaultLst, setDefaultList] = useState([]);
  const { isOpen, closePanel } = useSidePanel();

  useEffect(()=> {
   const initialVertical = cardData();
   setDefaultList(initialVertical);
  }, []);


  const getSortedData = useCallback((inputData) => {
    setDefaultList(inputData);
  }, []);

  const handleSaveData = () => {
    const resultData = defaultLst?.map((item) =>  item.id);
    storage.setObj(LS_KEY, resultData);
    closePanel();
  }

  const handleResetDefault = () => {
    setDefaultList(NavigationCardData);
  }

  const handleClose = () => {
    closePanel();
  }

  return (
    <div className={classes["edit-layout-panel"]}>
      <span className={`${classes["cross-btn"]} ${!isOpen && classes["hide"]}`} onClick={handleClose}><FontAwesomeIcon icon={faXmark} /></span>
      <header><span className={classes["head-text"]}><FontAwesomeIcon icon={faArrowLeft} /> Homepage</span></header>
      <div className={classes["content-head"]}>
        <span className={classes["title"]}>Dashboard Layout Preferences</span>
        <span className={classes["desc"]}>Customize how your dashboard cards are displayed and organized.</span>
      </div>
      <div className={classes["list-wrap"]}>
        <span className={classes["title"]}>Card Management</span>
      </div>
       {defaultLst?.length > 0 && <div className={classes["sortable-list-wrap"]}><SortableList initialItems={defaultLst} orientation="vertical" getSortedData={getSortedData} /> </div>}

      <footer>
        <button className={`${classes["reset-btn"]} ${classes["btn"]}`} onClick={handleResetDefault}><FontAwesomeIcon icon={faRotateLeft} />Reset to Default</button>
        <button className={`${classes["save-btn"]} ${classes["btn"]}`} onClick={handleSaveData}><FontAwesomeIcon icon={faCheck} />Save Changes</button>
      </footer>
    </div>
  );
}
